import { PriceList } from './PriceList';
import { Event } from './Event';
import { DeviceUserType } from './DeviceUserType';
import { Device } from './Device';

export class DeviceUser {
    public id: number;
    public name: string;
    public username: string;
    public allowOhViewing: boolean;
    public enablePaymentScreen: boolean;
    public showSales: boolean;
    public enableDoublePrint: boolean;
    public paidWithoutPrint: boolean;
    public enableSumUp: boolean;
    public enableVivaWallet: boolean;
    public enableWorldLine: boolean;
    public isvClientId: string;
    public isvClientSecret: string;
    public affiliateKey: string;
    public fiscalPrinterIP: string;
    public hasFiscalPrinter: boolean;
    public ohUpdateInterval: boolean;
    public showProductFilter: boolean;
    public lvlOnePin: number;
    public lvlTwoPin: number;
    public pinCode: number;
    public pinCodeUse: boolean;
    public priceList: PriceList = new PriceList();
    public event: Event = new Event();
    public deviceUserType: DeviceUserType = new DeviceUserType();
    public device: Device = new Device();
    public currency: string;
    public enableDebugging: boolean;
    public status: number;

    static fromDto(d: any): DeviceUser {
        const deviceUser = new DeviceUser();

        if (!d) {
            return null;
        }

        deviceUser.id = d.id;
        deviceUser.name = d.name;
        deviceUser.username = d.username;
        deviceUser.allowOhViewing = d.allowOhViewing;
        deviceUser.enablePaymentScreen = d.enablePaymentScreen;
        deviceUser.showSales = d.showSales;
        deviceUser.enableDoublePrint = d.enableDoublePrint;
        deviceUser.paidWithoutPrint = d.paidWithoutPrint;
        deviceUser.enableSumUp = d.enableSumUp;
        deviceUser.enableVivaWallet = d.enableVivaWallet;
        deviceUser.enableWorldLine = d.enableWorldLine;
        deviceUser.isvClientId = d.isvClientId;
        deviceUser.isvClientSecret = d.isvClientSecret;
        deviceUser.hasFiscalPrinter = d.hasFiscalPrinter;
        deviceUser.fiscalPrinterIP = d.fiscalPrinterIP;
        deviceUser.affiliateKey = d.affiliateKey;
        deviceUser.ohUpdateInterval = d.ohUpdateInterval;
        deviceUser.showProductFilter = d.showProductFilter;
        deviceUser.lvlOnePin = d.lvlOnePin;
        deviceUser.lvlTwoPin = d.lvlTwoPin;
        deviceUser.pinCode = d.pinCode;
        deviceUser.pinCodeUse = d.pinCodeUse;
        deviceUser.priceList = d.priceList;
        deviceUser.event = d.event;
        deviceUser.deviceUserType = d.deviceUserType;
        deviceUser.device = d.device;
        deviceUser.currency = d.currency;
        deviceUser.enableDebugging = d.enableDebugging;
        deviceUser.status = d.status;

        return deviceUser;
    }
}
